import { Toolbar } from "..";
import type { IconType } from "@circle-react-shared/Icon";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export interface ToolbarIconButtonProps {
  icon: IconType;
  onClick: () => void;
  tooltipText: string;
}

export const ToolbarIconButton = ({
  icon,
  tooltipText,
  onClick,
}: ToolbarIconButtonProps) => (
  <Toolbar.Tooltip content={tooltipText}>
    <IconButton
      name={icon}
      onClick={onClick}
      ariaLabel={tooltipText}
      className="hover:!bg-transparent"
      iconClassName="!text-current"
    />
  </Toolbar.Tooltip>
);
